import defaultAvatar from '@/assets/defaultAvatar.svg'
import Index from './index.vue'
import { ref, reactive, Ref } from 'vue'

export const useTeamPanel = (options: {
  avatar: string
  groupId: number
  allowUpload?: Ref<boolean>
}) => {
  const avatarModel = ref<string>(options.avatar || defaultAvatar)
  const props = ref({
    groupId: options.groupId,
    allowUpload: options.allowUpload ?? true
  })
  return reactive({
    avatarModel,
    props
  })
}

export default Index
